module.exports = __webpack_public_path__ + "media/img/cart-ico-07ddd52bced9aead9bcdd7c3670aadf5.svg";